import React from 'react'
import './scss/index.css'

type BoxFormProps = {
  title?: string
  header?: React.ReactNode
  footer?: React.ReactNode
}

class BoxForm extends React.PureComponent<BoxFormProps> {
  render() {
    // @ts-expect-error TS(2339): Property 'header' does not exist on type 'Readonly... Remove this comment to see the full error message
    const { children, header, title, footer, className, ...rest } = this.props
    return (
      <div className="BoxForm-root">
        {header && <div className="BoxForm-header">{header}</div>}
        <div className="BoxForm-main">
          {title && <div className="BoxForm-title">{title}</div>}
          <form {...rest} className={`BoxForm-form ${className}`}>
            {children}
          </form>
        </div>
        {footer && <div className="BoxForm-footer">{footer}</div>}
      </div>
    )
  }
}

export default BoxForm
